export const RECAPTCHA_SITE_KEY = "6Lfz-I8qAAAAAKUsl8O_nRL6SByk9BRWb8JPstGl";
export const RECAPTCHA_ACTION = "LOGIN";
export const RECAPTCHA_SCRIPT_URL = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;

export const hasRecaptchaEnterprise = (grecaptcha) => {
  return Boolean(grecaptcha && grecaptcha.enterprise);
};

export const loadRecaptchaEnterpriseScript = () => {
  if (document.querySelector(`script[src="${RECAPTCHA_SCRIPT_URL}"]`)) {
    return () => {};
  }

  const script = document.createElement("script");
  script.src = RECAPTCHA_SCRIPT_URL;
  script.async = true;
  document.head.appendChild(script);

  // Ne pas retirer le script : grecaptcha casse si le tag est démonté.
  return () => {};
};

export const executeRecaptcha = (action = RECAPTCHA_ACTION) => {
  return new Promise((resolve, reject) => {
    if (!hasRecaptchaEnterprise(window.grecaptcha)) {
      reject(new Error("reCAPTCHA non disponible"));
      return;
    }

    try {
      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(
            RECAPTCHA_SITE_KEY,
            { action }
          );
          resolve(token);
        } catch (error) {
          reject(error);
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};
